import useSWR from 'swr';

const fetcher = url => fetch(url).then(r => r.json());

export default function useTinyBanner() {
  const locale = window?.config?.language_code || 'en';
  const { data, error, isLoading } = useSWR(
    `/api/content/banners/?fields=*&locale=${locale}`,
    fetcher
  );

  const tinyBannerData = data?.items?.[0] || undefined;

  return {
    tinyBanner: tinyBannerData,
    isLoading,
    isError: error
  };
}
